import { FC, ReactNode } from 'react';

import { Creators } from '@components/creators';
import { ICreator } from '@interface/token';
import { Box, Text } from '@versumstudios/ui';

import * as Styles from './styles';

interface ITitles {
  inView: boolean;
  title?: string;
  creators: ICreator[];
  children?: ReactNode;
}

export const Titles: FC<ITitles> = ({ inView, title, creators, children }) => {
  return (
    <Styles.SmallTitle faded={inView}>
      <Box vertical>
        <Text unset ellipsis css={{ fontWeight: 700, overflow: 'hidden', marginRight: '$space$4' }}>
          {title}
        </Text>
        <Creators creators={creators} />
      </Box>
      <Box vertical css={{ '&>*': { marginLeft: '$4' } }}>
        {children}
      </Box>
    </Styles.SmallTitle>
  );
};
